'use client'

import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { cx } from 'utils/cx'

import styles from './Header.module.scss'
import text from 'fukku/styles/texts.module.scss'

interface HeaderProps {
	readonly errorMessage?: string
}

export function Header({ errorMessage }: HeaderProps): React.ReactNode {
	const { t } = useLabels()

	return (
		<>
			<h2 className={`${text.titleL} ${styles.title}`}>
				{t('myPurchases.login.check.title')}
			</h2>
			{errorMessage && (
				<p
					data-testid='myPurchases.orderForm.globalError'
					className={cx(text.bodyS, styles.globalError)}
				>
					{errorMessage}
				</p>
			)}
		</>
	)
}
